export default __webpack_public_path__ + "static/media/template-black-5230.812bcb92.png";